import { LinkToType } from 'hooks/navigation/types';

import { localeRoutes } from './intl';

export const relativeRoutes = {
  address: 'address',
  addCard: 'add-card',
  addExtra: 'extras',
  addGiftCard: 'add-gift-card',
  favorites: 'favorites',
  locationService: 'location-service',
  noDeliveryStores: 'no-delivery-stores',
  deliveryStoresClosed: 'delivery-stores-closed',
  orderPayment: 'payment',
  storeConfirmation: 'store-confirmation',
  pickupMode: 'pickup-mode',
  recentItems: 'recent-items',
  serviceMode: 'service-mode',
  serviceModeCatering: 'service-mode-catering',
  serviceModeCateringDelivery: 'service-mode-catering-delivery',
  serviceModeCateringPickup: 'service-mode-catering-pickup',
  store: 'store',
  sharedRolls: 'send',
  successGiftCard: 'success-gift-card',
  successTransferGiftCard: 'success-transfer-gift-card',
  transferBalance: 'transfer-balance',
  transferGiftCard: 'transfer-gift-card',
};

// TODO: BKPE-3: Cleanup all routes that are irrelevant to BK
export const routes = {
  aboutApp: '/about-app',
  accountMain: '/account/main',
  accountRequestInfo: '/account/request-information',
  accountDelete: '/account/delete',
  addCard: `/account/payment/${relativeRoutes.addCard}`,
  addGiftCard: `/account/payment/${relativeRoutes.addGiftCard}`,
  address: `/store-locator/${relativeRoutes.address}`,
  authChallengeJwt: '/auth-challenge-jwt',
  base: '/',
  baseMain: 'home',
  browseMenu: '/browse-menu',
  bkRewards: '/bkrewards',
  cart: '/cart',
  cartMain: '/cart/main',
  cartAddCard: `/cart/${relativeRoutes.orderPayment}/${relativeRoutes.addCard}`,
  cartAddExtras: `/cart/${relativeRoutes.addExtra}`,
  cartPayment: `/cart/${relativeRoutes.orderPayment}`,
  cartStoreConfirmation: `/cart/${relativeRoutes.orderPayment}/${relativeRoutes.storeConfirmation}`,
  cardPaymentAddGiftCard: `/cart/${relativeRoutes.orderPayment}/${relativeRoutes.addGiftCard}`,
  cartPaymentSuccessGiftCard: `/cart/${relativeRoutes.orderPayment}/${relativeRoutes.successGiftCard}`,
  cartPaymentTransferGiftCard: `/cart/${relativeRoutes.orderPayment}/${relativeRoutes.transferGiftCard}`,
  cartPaymentTransferSuccessGiftCard: `/cart/${relativeRoutes.orderPayment}/${relativeRoutes.successTransferGiftCard}`,
  cartTransferBalance: `/cart/${relativeRoutes.orderPayment}/${relativeRoutes.transferBalance}`,
  catering: `/catering`,
  claimPointsAccepted: '/claim-points/accepted',
  claimPointsBase: '/claim-points',
  claimPointsProcessing: '/claim-points/claim',
  claimPointsSurvey: '/claim-points/survey',
  communication: `/communication-preferences`,
  confirmJwt: '/confirm-jwt',
  confirmOtp: '/confirm-otp',
  delivery: '/delivery',
  deliveryStoresClosed: `/store-locator/${relativeRoutes.deliveryStoresClosed}`,
  diagnostics: '/diagnostics',
  drawer: 'Drawer',
  favoritesMain: `/menu/${relativeRoutes.favorites}/main`,
  favorites: `/menu/${relativeRoutes.favorites}`,
  favoriteEditor: `/menu/${relativeRoutes.favorites}/:favoriteId/edit`,
  accountInfo: '/account/info',
  issueCollector: '/issue-collector',
  languageSelector: '/language-selector',
  loading: '/loading',
  locationService: `/store-locator/${relativeRoutes.locationService}`,
  loyaltyDashboard: '/rewards/details',
  loyaltyHome: '/rewards',
  loyaltyRewardsDashboard: '/rewards/dashboard',
  loyaltyRewardsList: '/rewards/list',
  loyaltyOfferList: '/rewards/offers',
  menu: '/menu',
  menuEmpty: '/menu-empty',
  menuFavorites: '/menu/favorites',
  menuMain: '/menu/main',
  menuContent: '/menu-content',
  menuRecent: '/menu/recent-items',
  missingItems: '/missing-items',
  missingOrder: '/missing-order',
  noDeliveryStores: `/store-locator/${relativeRoutes.noDeliveryStores}`,
  notFound: '/not-found',
  notFound404: '/not-found/404',
  nutritionExplorer: '/nutrition-explorer',
  offers: '/offers',
  offersList: 'OffersList',
  orderConfirmation: '/order-confirmation',
  orders: '/account/orders',
  ordersDetails: '/account/orders/details',
  payment: '/account/payment',
  accountPaymentSuccessGiftCard: `/account/${relativeRoutes.orderPayment}/${relativeRoutes.successGiftCard}`,
  accountPaymentTransferSuccessGiftCard: `/account/${relativeRoutes.orderPayment}/${relativeRoutes.successTransferGiftCard}`,
  pickupMode: `/store-locator/${relativeRoutes.pickupMode}`,
  linkCard: `/link-card`,
  productDetail: '/product-detail',
  redeem: '/redeem',
  reportOrderIssue: '/digitalorderhelp',
  rewards: '/rewards',
  rewardsHistory: '/rewards/history',
  rewardsList: '/rewards-list',
  rewardsOnboarding: '/rewards-onboarding',
  scanMain: '/scan-main',
  scaryPlaces: '/scaryplaces',
  serviceMode: `/store-locator/${relativeRoutes.serviceMode}`,
  serviceModeCatering: `/store-locator/${relativeRoutes.serviceModeCatering}`,
  serviceModeCateringDelivery: `/store-locator/${relativeRoutes.serviceModeCateringDelivery}`,
  serviceModeCateringPickup: `/store-locator/${relativeRoutes.serviceModeCateringPickup}`,
  signOut: '/signout',
  staticPage: '/static-page',
  store: `/store-locator/${relativeRoutes.store}`,
  support: '/support',
  supportCategories: '/support/categories',
  supportCategory: '/support/categories/:categoryId',
  supportOrders: '/support/orders',
  supportForm: '/support/form',
  supportPage: 'SupportPage',
  tabs: 'Tabs',
  transferGiftCard: `/account/${relativeRoutes.orderPayment}/${relativeRoutes.transferGiftCard}`,
  accountTransferBalance: `/account/${relativeRoutes.orderPayment}/${relativeRoutes.transferBalance}`,
  trending: '/trending',
  contactUs: 'contact-us',
  offerActivate: '/activate-offer',
  modalStaticPage: '/modal-static-page',
  questLibrary: '/quest-library',
  favoriteStoreSearch: '/favorite-store-search',

  //TODO: this route is a static page in sanity. Ensure it exists in data set

  // Default localizable routes
  account: localeRoutes.en.account,
  acceptGift: localeRoutes.en.acceptGift,
  sendGift: localeRoutes.en.sendGift,
  signUp: localeRoutes.en.signUp,
  signIn: localeRoutes.en.signIn,
  storeLocator: localeRoutes.en.storeLocator,
  hockeyChallenge: localeRoutes.en.hockeyChallenge,
  foundation: '/foundation',
  scan: localeRoutes.en.scan,
};

// brand-specific routes used to determine whether to display service mode header
export const routesForBottomServiceModeDisplay = [
  { route: routes.base, exact: true },
  { route: `${routes.menu}/${relativeRoutes.recentItems}`, exact: true },
  { route: `${routes.browseMenu}/${relativeRoutes.recentItems}`, exact: true },
  { route: routes.favorites, exact: true },
  { route: routes.menu, exact: false },
  { route: routes.browseMenu, exact: false },
  { route: routes.orders, exact: false },
  { route: routes.offers, exact: false },
  { route: routes.loyaltyOfferList, exact: false },
];

// brand-specific routes used to determine whether to display top service mode header
export const routesForTopServiceModeDisplay = [
  { route: routes.base, exact: true },
  { route: `${routes.menu}/${relativeRoutes.recentItems}`, exact: true },
  { route: `${routes.browseMenu}/${relativeRoutes.recentItems}`, exact: true },
  { route: routes.favorites, exact: true },
  { route: routes.menu, exact: false },
  { route: routes.browseMenu, exact: false },
  { route: routes.orders, exact: false },
  { route: routes.offers, exact: false },
  { route: routes.redeem, exact: false },
  { route: routes.loyaltyRewardsList, exact: false },
  { route: routes.loyaltyOfferList, exact: false },
  { route: routes.loyaltyRewardsDashboard, exact: false },
];

export const isSectionRoute = (pathname: string) => pathname.startsWith(`${routes.menu}/section-`);

export const isRecentItemsRoute = (pathname: string) =>
  pathname.startsWith(`${routes.menu}/${relativeRoutes.recentItems}`);
export const isFavoritesRoute = (pathname: string) => pathname.startsWith(routes.favorites);

export const isItemPickerOrComboRoute = (pathname: string) =>
  new RegExp(`^${routes.menu}/(item|picker|combo)-`).test(pathname);

export function editFavorite({
  linkTo,
  favoriteId,
  popCurrent = false,
}: {
  linkTo: LinkToType;
  favoriteId?: string | null;
  popCurrent?: boolean;
}) {
  linkTo(`${routes.favorites}/${favoriteId}/edit`, { popCurrent });
}

export {
  localeRoutes,
  getAllLocalizedVersionsOfRoute,
  getInCodeLocalizedRouteForPath,
  getStaticPagesLocalizedRouteForPath,
} from './intl';
